import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { catalogGraphRouteRef } from '@backstage/plugin-catalog-graph';

// Same extension id as the one the catalog-graph plugin ships, which replaces it.
const catalogGraphPage = PageBlueprint.make({
  params: {
    path: '/catalog-graph',
    routeRef: catalogGraphRouteRef,
    loader: () =>
      import('./CatalogGraphRootPage').then(m => <m.CatalogGraphRootPage />),
  },
});

export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphPage],
});
